import React from 'react'
import { FilterForm } from '../../../components'

const Sidebar = ({setFiltered}) => {
  return (
    <div className="lg:pr-12" /* onClick={() => setFiltered(true)} */>
      <FilterForm id="sidebar-filter-form"/>
    </div>
  )
}

export { Sidebar }